import { Amplify,Auth } from "aws-amplify";

function getRedirectUri() {
  return process.env.REACT_APP_IS_LOCAL ==="true"
    ? 'http://localhost:3000'
    : process.env.REACT_APP_USER_BRANCH === 'dev'
      ? 'https://develop.d1lac6h76h2sv5.amplifyapp.com'
      : 'https://www.explorandes.app';
}

Amplify.configure({
  Auth: {
    region: process.env.REACT_APP_REGION,
    userPoolId: process.env.REACT_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID,
    oauth: {
      domain: process.env.REACT_APP_COGNITO_DOMAIN,
      scope: ["openid", "email", "profile"],
      redirectSignIn: `${getRedirectUri()}/callback`,
      redirectSignOut: `${getRedirectUri()}/`,
      responseType: "code",
    },
  },
});


Auth.configure({
  Auth: {
    region: process.env.REACT_APP_REGION,
    userPoolId: process.env.REACT_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID,
    oauth: {
      domain: process.env.REACT_APP_COGNITO_DOMAIN,
      scope: ["openid", "email", "profile"],
      redirectSignIn: `${getRedirectUri()}/callback`,
      redirectSignOut: `${getRedirectUri()}/`,
      responseType: "code",
    },
  },
});
